import { GroupWithLabels } from "./groupWithLabels";
import { WithLabel } from "./withLabel";

export const RadioCompositions = {
    WithLabel,
    GroupWithLabels,
};

export type { WithLabelProps as RadioWithLabelProps } from "./withLabel";
export type { GroupWithLabels as RadioGroupWithLabelsProps, RadioOption } from "./groupWithLabels";
